import {SActionBtn, SIDRender, SLowcodeList, STableActions} from "shj-components";
import config from "./config.tsx";
import React, {useEffect, useRef, useState} from "react";
import {getAuth} from "@/utils/btn.ts";
import {Tag, TreeSelect} from "antd";
import CheckThePhone from "@/components/CheckThePhone";
import {isNil} from "lodash-es";
import {useNavigate} from "react-router-dom";
import {getAllCompanyMrn, getRealEstateList, getTrackPlanPage} from "@/services/customerServices.ts";
import {apiData2Table} from "@/utils/data.ts";
import AddOrEditTrack from "@/pages/clueManage/clueDetail/components/Modals/AddOrEditTrack";
import {useSetState} from "ahooks";
import {getEnums, httpOrgList} from "@/services/homeService.ts";
import {getChannelCategoryTree} from "@/services/channelManagement.ts";
import {getChannelBrandAgent, getChannels, getChannelType} from "@/services/getUsers.ts";
import {departmentTree} from "@/services/content.ts";
import {filterSearchData, isHeadquarters} from "@/utils/common.ts";
import {getUser} from "@/common/utils.ts";
import AllowcateWorkerModal from "@/components/AllowcateWorkerModal";
import KeepAlive from "react-activation";
import {openInNewTab} from "@/utils/queryParse.ts";

const ClueListSale = () => {
  const {companyId} = getUser()
  const navigate = useNavigate()
  const listRef = useRef<any>()
  const [sourceChannel, setSourceChannel] = useState([])
  const [state, setState] = useSetState({
    open: false,
    record: {},
    changeDispatcherOpen: false, //改派
    batchEditId: [],
  })

  useEffect(() => {
    onCompanyChange(companyId)
  }, [companyId]);

  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      const {deptId, ucenterUserId} = query
      if (deptId || ucenterUserId) {
        query.relativesRequest = {
          deptId,
          ucenterUserId,
          dutyType:  ucenterUserId && "subsidiary.designer"
        }
      }
      const newQuery = filterSearchData(query, ['firstDate'])
      delete newQuery.deptId
      delete newQuery.ucenterUserId
      getTrackPlanPage({
        params: {pageId: current, pageSize},
        data: {...newQuery, queryExtendFlag: true, publicSeaFlag: true}}
      ).then((res)=>{
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }

  const onEdit = (record) => {
    setState({record, open: true})
  }

  const getStatusOptions = () => {
    return Promise.all([
      httpOrgList(),
      getChannels(),
      getChannelBrandAgent(),
      getChannelType(),
      getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.BizOpTypeEnum'),
      getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.TrackPlanStatusEnum'),
    ]).then(resp => {
      setSourceChannel(resp[1])
      return {
        companyList: resp[0],
        channels: resp[1],
        channelBrand: resp[2],
        channelType: resp[3],
        typeListArr: resp[4],
        clueStatusEnum: resp[5],
      }
    })
  }

  const onDesignDeptChange = (v) => {
    if (v) {
      getAllCompanyMrn({directlyUnder: {orgId: v, includeChild: true}}).then(res => {
        listRef?.current?.updateSearchData('designer', res)
      })
    } else {
      listRef?.current?.updateSearchData('designer', [])
    }
  }

  const onCompanyChange = async (value: any) => {
    if (value) {
      getRealEstateList({orgId: value}).then(res => {
        listRef?.current?.updateSearchData('buildingId', res)
      })
      departmentTree(value, {
        "direction": "DOWN"
      }).then(res => {
        listRef?.current?.updateSearchData('designDept', res)
      })
    } else {
      listRef?.current?.updateSearchData('buildingId', [])
      listRef?.current?.updateSearchData('designDept', [])
    }
  }

  const onSearchReset = () => {
    listRef?.current?.updateSearchData('buildingId', [])
    listRef?.current?.updateSearchData('designDept', [])
    listRef?.current?.updateSearchData('designer', [])
  }

  const onChangeEmp = (batchEditId) => {
    setState({batchEditId, changeDispatcherOpen: true})
  }

  const onBatchChange = ({selectedRowKeys}) => {
    onChangeEmp(selectedRowKeys)
  }

  const extension = {
    onSearchReset,
    request: {fetchList, getStatusOptions},
    events: {onCompanyChange, onDesignDeptChange, onBatchChange},
    auth: getAuth(),
    rowKey: 'id',
    status: {
      btnDisabled: ({selectedRowKeys}: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      clueIdRender(text: any, record: any, index: any) {
        const label = text
        return (
          <SIDRender
            id={label}
            onClick={() => {
              openInNewTab(`/saleOp/salesWorkBench/salesWorkBenchDetail/${record.clueId}?authKey=clueListSale`)
            }}
          />
        )
      },
      trackIdRender(text: any, record: any, index: any) {
        let label = text
        if (record?.sourceFlag == 'CONTENT_SHARING') {
          label += `-内`
        }
        return (
          <span>{label}</span>
        )
      },
      checkPhone(text: any, record: any, index: any) {
        return (
            <CheckThePhone
                clueId={record.clueId}
                initValue={text}
                auth="salePlanViewPhone"
            />
        )
      },
      grossInfoRender(text: any, record: any, index: any) {
        if (isNil(text)) return '待定'
        if (text || text == 'true') return '是'
        if (!text || text == 'false') return '否'
      },
      publicCell(text: any, record: any, index: any) {
        let content = '线索列表'
        switch (record?.publicSea) {
          case 'public_seat':
            content = '呼叫公海池'
            break
          case 'public_sales':
            content = '营销公海池'
            break
          case 'public_fangao':
            content = '梵高CC回访池'
            break
          case 'public_temp':
            content = '待二次派单'
            break
        }
        switch (record?.collisionFlag) {
          case true:
            content = '撞单异常'
            break
        }
        if (!!record?.dispatchExceptionType && record?.dispatchExceptionType != 'none') {
          content = '派单异常'
        }
        return content
      },
      stateRender(text){
        return <Tag color='pink'>{text}</Tag>
      },
      actionRender(_, record){
        return <STableActions>
          <SActionBtn auth={'trackInfoEdit'} onClick={() => onEdit(record)}>编辑</SActionBtn>
          {/*<SActionBtn>解除锁定</SActionBtn>*/}
          <SActionBtn auth={'reassignmentDesigner'}
                      onClick={() => onChangeEmp([record.id])}>改派设计师</SActionBtn>
        </STableActions>
      }
    },
  }

  return (
    <KeepAlive name={location.pathname}>
      <>
        <SLowcodeList config={{...config, [isHeadquarters() ? '' : 'searchInitialValues']: {orgId: companyId}}} ref={listRef} searchMode="group" {...extension} />
        { state.open && <AddOrEditTrack basicInfo={state.record}
                                        editReload={() => {}}
                                        reload={listRef.current?.reload}
                                        isEdit={true}
                                        open={state.open}
                                        onClose={() => setState({open: false, record: {}})} /> }
        {/** 分配服务人员弹窗 */}
        {state.changeDispatcherOpen &&
            <AllowcateWorkerModal isEditTitle={'改派'} isListOperation={true}
                                  buttonKey={'ASSIGN_DESIGNER'}
                                  reload={listRef.current?.reload}
                                  isBatch={true}
                                  trackPlanId={state.batchEditId} open={state.changeDispatcherOpen}
                                  onClose={() => setState({changeDispatcherOpen: false})}/>}
      </>
    </KeepAlive>
  )
}

export default ClueListSale